import { Stack } from "@mui/material";
import type { PropsWithChildren } from "react";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";

const WorkbookDetailsContainer = ({ children }: PropsWithChildren) => {
  return (
    <ScrollableFlexContainer sx={{ maxWidth: "380px", width: "100%", borderLeft: "1px solid", borderColor: "divider" }}>
      <Stack spacing={2} sx={{ pt: 1, pb: 2, px: 2.5 }}>
        {children}
      </Stack>
    </ScrollableFlexContainer>
  );
};

export default WorkbookDetailsContainer;
